import { useState } from 'react';
import '@popsure/dirty-swan/dist/index.css';

import Preview from './Preview';
import Notification from './Notification';

import './App.scss';
import { Button, Checkbox, LogoPositiveBlack } from '@popsure/dirty-swan';

function App() {
  const [info, setInfo] = useState({
    name: '',
    position: '',
    pronouns: '',
    showSocialMedia: false,
  });
  const [status, setStatus] = useState(null);

  const handleInputChange = (key) => (e) => {
    if (e.type === 'checkbox') {
      setInfo({ ...info, [key]: e.value });
    } else {
      setInfo({ ...info, [key]: e.target.value });
    }
  };

  const handleCopyToClipboard = () => {
    setStatus(null);
    try {
      const preview = document.getElementById('preview');

      if (window.ClipboardItem) {
        const blobInput = new Blob([preview.innerHTML], { type: 'text/html' });
        const clipboardItemInput = new window.ClipboardItem({
          'text/html': blobInput,
        });
        navigator.clipboard.write([clipboardItemInput]).then(() => {
          setStatus('Copied to clipboard ✅');
        });
      } else {
        const selection = window.getSelection();
        selection.removeAllRanges();

        const range = document.createRange();
        range.selectNodeContents(preview);
        selection.addRange(range);

        document.execCommand('copy');

        selection.removeAllRanges();
        setStatus('Copied to clipboard ✅');
      }
    } catch (e) {
      setStatus(`Copy failed ❌: ${e.message}`);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <LogoPositiveBlack width={160} />
      </header>
      <div className="container">
        <p className="p-p mb16 ta-center">
          Not sure how to setup your new signature?&nbsp;
          <a
            className="p-a"
            href="https://notion.so/featherinsurance/How-to-set-up-your-email-signature-2761aa4c33884c108a5190b3c6c54bd8"
            target="_blank"
            rel="noopener noreferrer"
          >
            Click here for instructions
          </a>
        </p>
      </div>
      <div className="container">
        <div className="modal">
          <h1 className="p-h1 p--serif">Email Signature Generator</h1>
          <p className="p-p">
            Use this tool to generate your own Feather email signature.
          </p>
          <form className="mt24 mb24">
            <label>
              <p className="p-p">Full name</p>
              <input
                className="p-input"
                data-testid="name-input"
                onChange={handleInputChange('name')}
                value={info.name || ''}
              />
            </label>
            <label>
              <p className="p-p">What I do</p>
              <input
                className="p-input"
                data-testid="position-input"
                onChange={handleInputChange('position')}
                value={info.position || ''}
              />
            </label>
            <label>
              <p className="p-p">Pronouns</p>
              <input
                className="p-input"
                data-testid="position-input"
                onChange={handleInputChange('pronouns')}
                value={info.pronouns || ''}
              />
            </label>
            <label>
              <Checkbox
                options={{
                  showSocialMedia: 'Show social media icons'
                }}
                inlineLayout
                bordered={false}
                onChange={(checkboxValues) => handleInputChange('showSocialMedia')({
                  type: 'checkbox',
                  value: checkboxValues?.[0],
                })}
                value={info?.showSocialMedia ? ['showSocialMedia'] : []}
              />
            </label>
          </form>
          <p className="p-p">This is how your new signature will look like:</p>
          <div className="mt48 w100 d-flex" id="preview">
            <Preview
              name={info.name}
              position={info.position}
              pronouns={info.pronouns}
              showSocialMedia={info.showSocialMedia}
            />
          </div>

          <div className="mt48">
            <Button
              className="w100"
              onClick={handleCopyToClipboard}
            >
              Copy to clipboard
            </Button>
          </div>
        </div>
      </div>
      {status && <Notification description={status} />}
    </div>
  );
}

export default App;
